/* @ngInject */
export default function DirectoryBoxController($scope, $attrs, $window, $rootScope, productLookupService, raSpinnerService, categoryCacheService, geoStateCacheService) {
    const vm = this;
    vm.category = null;
    vm.iconClass = null;
    vm.currentState = geoStateCacheService.getCurrentStateObject();
    let categoryId = null;


    if ($scope.category) {
        categoryId = $scope.category.Id;
    }

    switch (categoryId) {
    case 1:
        vm.iconClass = 'hvac';
        break;
    case 2:
        vm.iconClass = 'solar';
        break;
    case 3:
        vm.iconClass = 'roofing';
        break;
    case 4:
        vm.iconClass = 'windowdoor';
        break;
    case 5:
        vm.iconClass = 'insulation';
        break;
    case 6:
        vm.iconClass = 'plumbing';
        break;
    case 7:
        vm.iconClass = 'waterheating';
        break;
    case 8:
        vm.iconClass = 'landscaping';
        break;
    case 9:
        vm.iconClass = 'altenergy';
        break;
    case 10:
        vm.iconClass = 'lighting';
        break;
    case 11:
        vm.iconClass = 'pool';
        break;
    case 13:
        vm.iconClass = 'wind';
        break;
    }


    const data = categoryCacheService.getCategories();
    for (let i = 0; i < data.length; i++) {
        if (data[i].Id === parseInt(categoryId)) {
            vm.category = data[i];
        }
    }

    vm.getUrl = function (type) {
        const currentGeoState = geoStateCacheService.getCurrentStateObject();
        if (currentGeoState !== undefined) {
            const GeoStateAbbreviation = currentGeoState.StateAbbreviation;

            return type.NoProducts ? `/product-lookup/detail/${GeoStateAbbreviation}/${type.EETypeId}_${type.NoProductProductId}` : `/product-lookup/search/${GeoStateAbbreviation}/${type.EETypeId}?query=&filters=`;
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/productCenter/pages/productdirectory/directoryBox/directoryBox.controller.js